import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import {
  Button, Modal, Typography,
} from "antd";

import "./PanelOverrideUndoNotice.css";

export default function PanelOverrideUndoNotice({
  open,
  panelName,
  removedNames = [],
  onUndo,
  onConfirm,
  onClose,
}) {
  if (!open) return null;

  return (
    <Modal
      open
      centered
      width={520}
      closable
      destroyOnHidden
      wrapClassName="PanelOverrideUndoNotice"
      className="PanelOverrideUndoNotice"
      closeIcon={<CloseOutlined />}
      onCancel={onClose || onConfirm}
      title={`${panelName} Panel spec will be used`}
      footer={(
        <div className="PanelOverrideUndoNotice__footerActions">
          <Button
            type="default"
            htmlType="button"
            onClick={onUndo}
          >
            Undo
          </Button>
          <Button
            type="primary"
            htmlType="button"
            onClick={onConfirm}
          >
            Confirm
          </Button>
        </div>
      )}
    >
      <Typography.Paragraph className="PanelOverrideUndoNotice__message">
        {panelName}
        {" now overrides "}
        {removedNames.join(", ")}
        {". Individual test specs no longer apply for those tests."}
      </Typography.Paragraph>
    </Modal>
  );
}
